import React from 'react'
import OptionsContainer from './OptionsContainer'

const Options = () => <OptionsContainer data-test="component-options" />

export default Options
